import * as React from 'react';
import { AnchorListItem } from './AnchorListItem';
import { AppName } from '@pec/aion-ui-core/interfaces/appName';
import { DotBadge } from '../DotBadge';
import { faHardHat } from '@fortawesome/free-solid-svg-icons/faHardHat';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { InlineBadge } from '../InlineBadge';
import { NavLinkListItem } from './NavLinkListItem';
import { useTranslation } from 'react-i18next';

type Props = {
  navExpanded: boolean;
  notificationCount: number | null;
  organizationId: string;
};

const icon = <FontAwesomeIcon icon={faHardHat} />;

export const SafetyProgramsComponent: React.FC<Props> = ({ navExpanded, notificationCount, organizationId }) => {
  const showDotBadge = !navExpanded && notificationCount;
  const { t } = useTranslation();

  return process.env.REACT_APP_NAME === AppName.AionSafetyProgramsUI ? (
    <NavLinkListItem
      divider
      tooltip={!navExpanded}
      to={`/organizations/${organizationId}/safety-program-requirements`}
      icon={showDotBadge ? <DotBadge>{icon}</DotBadge> : icon}
    >
      <InlineBadge badgeContent={notificationCount}>
        {t('components.safetyPrograms.programReviews', 'Program Reviews')}
      </InlineBadge>
    </NavLinkListItem>
  ) : (
    <AnchorListItem
      divider
      tooltip={!navExpanded}
      href={`/organizations/${organizationId}/safety-program-requirements`}
      icon={showDotBadge ? <DotBadge>{icon}</DotBadge> : icon}
    >
      <InlineBadge badgeContent={notificationCount}>
        {t('components.safetyPrograms.programReviews', 'Program Reviews')}
      </InlineBadge>
    </AnchorListItem>
  );
};
